import { _Post, _Get } from '../helpers/Network';

export async function rateApi(params) {
    const rate = await post('/api/conversation/rate', params);
    return rate;
}
export async function webInfoApi(params) {
    const webInfo = await get('/api/website/setting', params);
    return webInfo.data;
}
export async function requestClientIdApi() {
    const clientId = await post('/api/client/create-client-id', {});
    return clientId.client_id;
}

export async function saveClientInfoApi(params) {
    const saveClient = await post('/api/client/save-client-info-client', params);
    return saveClient;
}

export async function sendInboxApi(params) {
    const sendInbox = await post('/api/client/send-inbox', params);
    return sendInbox;
}



function post(url, params) {
    return new Promise((resolve) => {
        _Post(url, params, (e, r) => {
            resolve(r);
        });
    });
}
function get(url, params) {
    return new Promise((resolve) => {
        _Get(url, params, (e, r) => {
            resolve(r);
        });
    });
}



// WEBPACK FOOTER //
// ./src/api/fetch.js